<section>
  <!-- <h4>{{ data.label }}</h4> -->
  <mat-form-field class="date">
    <mat-label class="date-label">Izaberite datum</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      (dateInput)="onDataChange($any($event).value)"
      (dateChange)="onDataChange($any($event).value)"
      (input)="onDataChange($any($event.target).value)"
      [value]="data.state.value"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</section>
